// Optimized WebP assets (Phase 04A.1): downloaded from the original sources, resized to rendered size,
// metadata stripped, re-encoded with Pillow WebP (method 6). File names mirror the original seq ids.

// Hero image pairs: five scroll scenes, two images each.
export const heroPairs = [
  {
    id: '01',
    left: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-l-01.webp',
      alt: 'Contemporary villa facade in flawless smooth chalk-white mineral render with a slender bronze-framed window in a sharp deep reveal',
    },
    right: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-r-01.webp',
      alt: 'Tall minimalist villa volume in smooth warm ochre render with a slender bronze-framed window, olive tree and grasses at its base',
    },
  },
  {
    id: '02',
    left: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-l-02.webp',
      alt: 'Honed pale limestone block facade of a modern villa with tight horizontal stone joints and one tall narrow slot window, seen frontally in soft morning light, cream and bone tones, large calm stone surface, thin strip of pale blue grey sky at top',
    },
    right: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-r-02.webp',
      alt: 'Exterior stair of a minimalist courtyard house built from smooth taupe plaster, steps climbing diagonally along a wall, bold zigzag shadow pattern cast by hard sun, warm grey brown palette, strong graphic light and shade composition',
    },
  },
  {
    id: '03',
    left: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-l-03.webp',
      alt: 'Georgian townhouse front freshly restored in ivory lime stucco with black painted front door, fanlight above, white sash windows and wrought iron railings, street level view, soft overcast light, heritage elegance, immaculate restoration',
    },
    right: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-r-03.webp',
      alt: 'Ornate restored stucco cornice and classical moulded pilaster capital on a heritage building, looking upward, crisp repaired mouldings in warm stone colored render, golden side light revealing relief detail, deep blue grey sky behind',
    },
  },
  {
    id: '04',
    left: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-l-04.webp',
      alt: 'Brutalist inspired white concrete look render house with a dramatic cantilevered box floating over a recessed glazed ground floor, low angle view, bright noon sun, stark white and cool grey palette, sharp black shadow underneath',
    },
    right: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-r-04.webp',
      alt: 'Rhythmic row of deep vertical fins on a sand colored mineral render facade, repeating pattern of light and shadow stripes, oblique close view, warm afternoon sun, abstract architectural geometry, beige and amber tones',
    },
  },
  {
    id: '05',
    left: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-l-05.webp',
      alt: 'Mediterranean house wall in rich burnt sienna lime plaster at dusk with a single round porthole window glowing warm from inside, olive tree shadow on the wall, deep orange red earth palette, moody sophisticated evening atmosphere',
    },
    right: {
      src: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_hero-r-05.webp',
      alt: 'Dark chocolate brown tadelakt style polished plaster exterior wall with an arched doorway in blackened bronze, subtle satin sheen and trowel swirls, low warm lantern light from one side, very dark moody luxurious tones',
    },
  },
];

export const projects = [
  {
    slug: 'chalk-house',
    number: '01',
    title: 'Chalk House',
    finish: 'Mineral Refinish',
    surface: 'Existing cement render',
    scope: 'Surface repair, mineral finish coat, color matching',
    summary:
      'A two-storey residence with tired, patch-repaired render. Surfaces were consolidated and given a breathable chalk-toned mineral finish to unify the facade.',
    narrative: [
      'Earlier repairs had left visible patches and uneven absorption across the main elevation. Loose areas were removed and cracks opened, filled and allowed to cure before any finish work.',
      'A mineral finish in a warm chalk tone was applied by hand in two passes, keeping a soft, slightly irregular surface that reads differently as the light moves across the day.',
    ],
    cover: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_chalk-cover.webp',
    coverSm: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_chalk-cover-sm.webp',
    gallery: [
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_chalk-g1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_chalk-g2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_chalk-g3.webp',
    ],
  },
  {
    slug: 'courtyard-residence',
    number: '02',
    title: 'Courtyard Residence',
    finish: 'Stucco Renewal',
    surface: 'Traditional stucco',
    scope: 'Crack repair, texture matching, fine stucco top coat',
    summary:
      'Courtyard walls with hairline cracking and worn texture. The stucco was repaired and renewed with a fine hand-finished top coat in a warm taupe.',
    narrative: [
      'The enclosed courtyard walls had weathered unevenly, with the most exposed elevation showing hairline cracks and a washed-out surface.',
      'After repair, sample panels were made on site to agree texture and tone before the fine stucco top coat was applied across all four walls.',
    ],
    cover: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_court-cover.webp',
    coverSm: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_court-cover-sm.webp',
    gallery: [
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_court-g1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_court-g2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_court-g3.webp',
    ],
  },
  {
    slug: 'north-facade',
    number: '03',
    title: 'North Facade',
    finish: 'Surface Restoration',
    surface: 'Lime render over masonry',
    scope: 'Render consolidation, lime repairs, protective finish',
    summary:
      'A shaded north elevation with weathered lime render. Damaged areas were repaired in compatible lime and the facade given a breathable protective finish.',
    narrative: [
      'North-facing walls dry slowly. Sections of render had softened and detached, and earlier non-breathable paint was trapping moisture in places.',
      'Unsound material was removed, repairs carried out in a compatible lime mix, and a breathable finish chosen so the wall can continue to release moisture.',
    ],
    cover: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_north-cover.webp',
    coverSm: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_north-cover-sm.webp',
    gallery: [
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_north-g1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_north-g2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_north-g3.webp',
    ],
  },
  {
    slug: 'weathered-lime-cottage',
    number: '04',
    title: 'Weathered Lime Cottage',
    finish: 'Limewash Restoration',
    surface: 'Lime render over rubble masonry',
    scope: 'Cleaning, lime repairs, multi-coat limewash',
    summary:
      'An older cottage whose limewash had worn back to bare render. Loose material was cleaned off, repaired in lime and rebuilt in thin, layered limewash coats.',
    narrative: [
      'Years of weather had stripped the limewash unevenly, leaving bare patches and some softened render near the base of the walls.',
      'After lime repairs had cured, limewash was applied in several thin coats so the surface keeps its soft, clouded variation rather than a flat painted look.',
    ],
    cover: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_cottage-cover.webp',
    coverSm: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_cottage-cover-sm.webp',
    gallery: [
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_cottage-g1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_cottage-g2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_cottage-g3.webp',
    ],
  },
  {
    slug: 'stone-facade-house',
    number: '05',
    title: 'Stone Facade House',
    finish: 'Natural Stone Renovation',
    surface: 'Natural stone with lime pointing',
    scope: 'Cleaning, repointing in lime, surface consolidation',
    summary:
      'A textured natural stone facade with eroded joints and surface soiling. Stone was gently cleaned and repointed in a lime mortar matched to the original.',
    narrative: [
      'Hard cement pointing from an earlier repair had cracked away, and water was finding its way into the joints on the most exposed elevation.',
      'The cement was carefully raked out and joints repointed in lime, with mortar colour and texture agreed on a test area before the full facade.',
    ],
    cover: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_stone-cover.webp',
    coverSm: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_stone-cover-sm.webp',
    gallery: [
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_stone-g1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_stone-g2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_stone-g3.webp',
    ],
  },
  {
    slug: 'linear-house',
    number: '06',
    title: 'Linear House',
    finish: 'Mineral Render Detailing',
    surface: 'Insulated render system',
    scope: 'Mineral top coat, edge and reveal detailing',
    summary:
      'A contemporary house with crisp geometric volumes. A fine mineral render top coat was applied with careful attention to corners, reveals and junctions.',
    narrative: [
      'The design depended on clean edges and continuous planes, so corner beads, window reveals and the junction with the plinth were set out precisely before finishing.',
      'A fine-grain mineral top coat in a warm grey was applied in a single controlled pass per elevation to avoid visible joints across the long walls.',
    ],
    cover: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_linear-cover.webp',
    coverSm: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_linear-cover-sm.webp',
    gallery: [
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_linear-g1.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_linear-g2.webp',
      'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_linear-g3.webp',
    ],
  },
];

export const materials = [
  {
    name: 'Limewash',
    note: 'Thin, translucent mineral wash with a soft, clouded tone. Breathable; suits porous mineral substrates.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_mat-limewash.webp',
  },
  {
    name: 'Mineral Render',
    note: 'Cementitious or lime-based render built up in coats. Forms the protective skin of the wall.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_mat-mineral.webp',
  },
  {
    name: 'Textured Stucco',
    note: 'Hand-applied finish coat with deliberate relief. Texture is agreed on sample panels before work.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_mat-stucco.webp',
  },
  {
    name: 'Protective Coating',
    note: 'Weather-resistant top layer chosen for the substrate. Breathability is checked case by case.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_mat-protect.webp',
  },
];

export const services = [
  {
    id: 'restoration',
    number: '01',
    title: 'Exterior Wall Restoration',
    short: 'Repair of cracks, worn render and damaged surfaces before any finish is applied.',
    body: 'We assess why a surface has failed — movement, moisture, incompatible earlier repairs — and repair it in materials suited to the wall. Restoration is the foundation for every finish that follows.',
    situations: ['Cracked or hollow-sounding render', 'Patchy earlier repairs', 'Spalling or detached areas', 'Weathered, eroded surfaces'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_svc-restoration.webp',
  },
  {
    id: 'stucco',
    number: '02',
    title: 'Stucco & Render Finishes',
    short: 'Renewal of stucco and render, from smooth float finishes to fine textured coats.',
    body: 'New finish coats over sound existing render, or full re-rendering where needed. Texture and tone are agreed on sample panels so the finished wall matches what was approved.',
    situations: ['Tired or dated facades', 'Texture matching after repairs', 'Garden and boundary walls', 'Full facade renewal'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_svc-stucco.webp',
  },
  {
    id: 'mineral',
    number: '03',
    title: 'Mineral & Lime-Based Coatings',
    short: 'Breathable mineral finishes and limewash, where the substrate is suitable.',
    body: 'Lime and mineral coatings allow many traditional walls to release moisture and give a depth of tone that paint rarely matches. We confirm substrate compatibility before recommending them.',
    situations: ['Lime-rendered or older masonry walls', 'Walls previously sealed with non-breathable paint', 'Clients seeking a soft, mineral appearance'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_svc-mineral.webp',
  },
  {
    id: 'protection',
    number: '04',
    title: 'Surface Protection & Maintenance',
    short: 'Weather-resistant coatings and ongoing care to keep finished walls in good order.',
    body: 'Protective finishes selected for the substrate and exposure, and periodic inspection and maintenance so small issues are handled before they become repairs.',
    situations: ['Exposed or weather-facing elevations', 'Recently finished walls', 'Periodic inspection and touch-up'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_svc-protection.webp',
  },
];

export const processSteps = [
  { number: '01', title: 'Site Assessment', text: 'We inspect the walls, identify substrate and causes of damage, and agree the scope with you.' },
  { number: '02', title: 'Finish & Color Direction', text: 'Material and tone are selected for the wall, then confirmed on sample panels on site.' },
  { number: '03', title: 'Restoration & Application', text: 'Repairs are completed and allowed to cure before finishes are applied by hand.' },
];

export const workTypes = [
  'Exterior Wall Restoration',
  'Stucco & Render Finishes',
  'Mineral & Lime-Based Coatings',
  'Surface Protection & Maintenance',
  'Not sure yet',
];

export const philosophyImage = 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_philosophy.webp';

export const processImage = 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_process.webp';

export const ctaImage = 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_cta-wall.webp';

export const servicesHeroImage = 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_services-hero.webp';

export const contactHeroImage = 'https://public.readdy.ai/ai/img_res/sandbox/e37aefa5d5e32a61839389a854cb72c2/3b3843c7-325b-47ea-905b-54d1ab4ccc7e_contact-hero.webp';